import { Link } from "../lib/route";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service, testIdPrefix = "service" }) {
  return (
    <article
      data-testid={`${testIdPrefix}-card-${service.slug}`}
      className="group relative flex flex-col bg-[#fffdf9] rounded-2xl border border-[#e5e0d8] overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(44,42,41,0.12)]"
    >
      <div className="relative aspect-[16/11] overflow-hidden bg-gradient-to-br from-[#e5e0d8] via-[#f5efe4] to-[#c85a3c]/20">
        {service.image ? (
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-display text-4xl md:text-5xl font-black text-[#c85a3c]/70 tracking-tight">
              {(service.title || "?").slice(0, 2).toUpperCase()}
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#2c2a29]/40 to-transparent" />
        <div className="absolute top-4 left-4 text-[10px] tracking-[0.24em] uppercase font-bold bg-[#fffdf9] text-[#2c2a29] px-3 py-1.5 rounded-full">
          Service
        </div>
      </div>
      <div className="flex flex-col flex-1 p-6 md:p-7">
        <h3 className="font-display text-xl md:text-2xl font-bold text-[#2c2a29] leading-tight">
          {service.title}
        </h3>
        <p className="mt-3 text-sm text-[#5c5855] leading-relaxed">
          {service.short}
        </p>
        <div className="mt-6 flex items-center justify-between pt-5 border-t border-[#e5e0d8]">
          <Link
            to="/services"
            data-testid={`${testIdPrefix}-learn-${service.slug}`}
            className="text-sm font-bold text-[#2c2a29] hover:text-[#c85a3c] inline-flex items-center gap-2 transition-colors"
          >
            Learn more
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            to="/consultations"
            data-testid={`${testIdPrefix}-quote-${service.slug}`}
            className="text-xs font-bold text-[#c85a3c] hover:text-[#a64b32] uppercase tracking-wider"
          >
            Request Quote
          </Link>
        </div>
      </div>
    </article>
  );
}
